import previewDataLayer from './previewDataLayer'
import homeDataLayerHeader from './homeDataLayerHeader'
import homeDataLayerBody from './homeDataLayerBody'
import apartmentsDataLayer from './apartmentsDataLayer'
import productDataLayer from './productDataLayer'
import contactDataLayer from './contactDataLayer'
import lpVivantagensDataLayerBody from './lpVivantagensDataLayerBody'
import bannersDataLayer from './bannersDataLayer'
import bannerClickDataLayer from './bannerClickDataLayer'
import genericModalDataLayer from './genericModalDataLayer'
import handleBlurDatalayer from './formDataLayer'

export {
  previewDataLayer,
  homeDataLayerHeader,
  homeDataLayerBody,
  apartmentsDataLayer,
  productDataLayer,
  contactDataLayer,
  lpVivantagensDataLayerBody,
  bannersDataLayer,
  bannerClickDataLayer,
  genericModalDataLayer,
  handleBlurDatalayer,
}


// WEBPACK FOOTER //
// ./src/helpers/BI/index.js